import React from 'react';
import { CheckoutButton } from '../CheckoutButton';
import { CLOSING_BUY_LABEL } from '../../data/checkout';
export function FinalCta() {
  return <section aria-labelledby="cierre-title" className="w-full bg-coral-deep" data-id="element-206" data-mp="22d2xik5fi9xm">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:px-8 lg:py-24" data-id="element-207" data-mp="1no6lyd45yes9">
        <svg viewBox="0 0 120 4" preserveAspectRatio="none" className="mx-auto h-1 w-16" aria-hidden data-id="element-208" data-mp="1sn16bjhs4beh">
          <line x1="2" y1="2" x2="118" y2="2" stroke="#FFFFFF" strokeOpacity="0.7" strokeWidth="2" strokeLinecap="round" strokeDasharray="7 6" vectorEffect="non-scaling-stroke" data-id="element-209" data-mp="1en8gdqe2tz7k" />
        </svg>
        <h2 id="cierre-title" className="mt-5 font-serif text-[2.1rem] font-semibold leading-[1.1] text-white text-balance sm:text-[3rem]" data-id="element-210" data-mp="14qx0yrj6wt8w">
          Dale forma a tu emprendimiento de ropa infantil.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[1.1rem] leading-relaxed text-white sm:text-[1.2rem]" data-id="element-211" data-mp="2z2247uqd73np">
          Elegí entre 31 modelos, imprimí tus moldes y empezá a confeccionar las prendas que querés ofrecer.
        </p>
        <div className="mx-auto mt-9 flex w-full min-w-0 max-w-full justify-center" data-id="element-212" data-mp="3tffqhcg3867d">
          <CheckoutButton id="final-cta" label={CLOSING_BUY_LABEL} size="lg" tone="inverse" data-id="element-213" data-mp="3tdlfapumbsgh" />
        </div>
      </div>
    </section>;
}